const angular = require('angular');
const amt_admin = require('amt_admin').default;
const app = angular.module('ww2_analytics.arpu', [amt_admin]);

app.service('arpu_api', ['jsonrpc', function (jsonrpc) {
    const service = jsonrpc.newService('arpu');
    this.by_months = service.createMethod('by_months');
}]);

app.config([
  '$stateProvider',
  function($stateProvider) {
    $stateProvider.state('amt.ww2.arpu', {
      url: '/arpu',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: 'ARPU/ARPPU',
        role: 'arpu'
      },
      menu: {
        glyphicon: 'stats',
        childs: [
          {
            glyphicon: 'stats',
            state: 'amt.ww2.arpu.dynamic'
          },
          {
            glyphicon: 'stats',
            state: 'amt.ww2.arpu.by_months'
          }
        ]
      },
    })
    .state('amt.ww2.arpu.dynamic', require('./dynamic').default)
    .state('amt.ww2.arpu.by_months', require('./by_months').default);
  }
]);

export default app.name;
